// Function to send search event to Klaviyo directly
function sendSearchEventToKlaviyo(query, resultCount) {
    console.log('[KLAVIYO] Preparing to send KLAVIYO event via _learnq - Query:', query, 'Results:', resultCount);
    // Send using _learnq (Klaviyo's global object)
    if (window._learnq) {
        try {
            window._learnq.push(['track', 'Searched Site', {
                'SearchTerm': query,
                'ReturnedResults': resultCount
            }]);
            console.log('[KLAVIYO] Search event sent');
        } catch (e) {
            console.error('[KLAVIYO] Failed to send via _learnq:', e);
        }
    } else {
        console.warn('[KLAVIYO] _learnq not available');
    }
}

// Initialize search tracking
document.addEventListener('DOMContentLoaded', async function() {
    // Wait for commerce interface
    let commerceInterface = null;
    for (let i = 0; i < 20; i++) {
        commerceInterface = document.querySelector('#search-page');
        if (commerceInterface && commerceInterface.engine) break;
        await new Promise(resolve => setTimeout(resolve, 500));
    }

    if (!commerceInterface || !commerceInterface.engine) {
        console.error('[KLAVIYO] Commerce interface not found');
        return;
    }

    const engine = commerceInterface.engine;

    let debounceTimer = null;
    let lastSentQuery = null; // Track the last query we sent to Klaviyo

    // Process state and send event
    const processState = () => {
        const state = engine.store.getState();

        if (!state) return;

        // Get query from commerceQuery
        const currentQuery = state.commerceQuery?.query || '';

        // Get total count from pagination state (matching atomic-commerce-load-more-products pattern)
        const totalCount = state.commercePagination?.principal?.totalEntries || 0;
        const isLoading = state.commerceSearch?.isLoading;
        const responseId = state.commerceSearch?.responseId;

        console.log('[KLAVIYO DEBUG] Query:', currentQuery, 'Count:', totalCount, 'Loading:', isLoading, 'ResponseId:', responseId);
        // Only send if search is completed, we have results, and query has changed
        if (responseId && isLoading === false && currentQuery !== lastSentQuery) {
            sendSearchEventToKlaviyo(currentQuery, totalCount);
            lastSentQuery = currentQuery; // Update tracking variable
        }
    };

    // Subscribe with debouncing
    engine.subscribe(() => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(processState, 1000);
    });

    // Process initial state once subscription is set up
    processState();
});